import React from "react";
import { useSelector } from "react-redux";
import useAppDispatch from "@/Hooks/useAppDispatch";
import { Layout } from "antd";
import { BellOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import classnames from "classnames";
import { AppPathNames } from "@/constants/AppPathNames";
import { requestSignOut } from "@/store/effects/auth-effects";
import { slices } from "@/constants/sliceNames";

import User from "../User";
import AppLogo from "../../ui/AppLogo";

import "./Header.scss";

const { Header: LayoutHeader } = Layout;

/**
 * Header component: responsible for main website header
 * that can be seen from dashboard page
 * used in Layout component
 * @param {boolean} isLearnOpened is learn section opened
 * @param {(void)=>void} onLearnClick function to toggle isLearnOpened
 */
const Header = ({ isLearnOpened, onLearnClick }) => {
  const dispatch = useAppDispatch();
  const userName = useSelector((state) => state[slices.auth].userName);

  /**
   * on signout method:
   * dispath action to redux
   */
  const onSignOut = () => dispatch(requestSignOut());

  return (
    <LayoutHeader className="header">
      <AppLogo withTitle={false} imageClassName="header__logo" to={`${AppPathNames.dashboard}`} imgName="logo1.png" />
      <div className="header__controls">
        <BellOutlined className="header__icon header__icon--disabled" />
        <QuestionCircleOutlined
          className={classnames("header__icon header__icon--disabled", {
            "header__icon--active": isLearnOpened,
          })}
          // onClick={onLearnClick}
        />
        <User userName={userName || "Unknown"} onSignOut={onSignOut} />
      </div>
    </LayoutHeader>
  );
};

export default Header;
